import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

import CustomButton from "components/atoms/CustomButton";
import moment from "moment";
import CustomModal from "components/atoms/CustomModal";
import TestResultModal from "components/molecules/lab/modalContents/TestResultModal";

const getRowId = (row) => row?._id || row?.id;

const Row = ({ row, i, openModal }) => {
  return (
    <TableRow
      sx={{
        "&:nth-of-type(odd)": {
          backgroundColor: "background.custom",
        },
        "&:last-child td, &:last-child th": { border: 0 },
      }}
    >
      <TableCell align="left">{i + 1}</TableCell>
      <TableCell align="left" sx={{ color: "primary.darkGrey" }}>
        {moment(row.createdAt).format("MMMM Do, YYYY")}
      </TableCell>

      <TableCell align="left" sx={{ color: "primary.darkGrey" }}>
        {row.uniqueCode}
      </TableCell>

      <TableCell align="left">{`${row.patient.firstName} ${row.patient.lastName}`}</TableCell>

      <TableCell align="left" sx={{ color: "primary.darkGrey" }}>
        {row.patient.age}/{row.patient.gender}
      </TableCell>
      <TableCell align="left" sx={{ color: "primary.darkGrey" }}>
        {row?.doctor?.fullName}
      </TableCell>
      <TableCell align="left">
        <CustomButton
          text={"View Result"}
          variant="containedBrown"
          onClick={() => openModal(row)}
        />
      </TableCell>
    </TableRow>
  );
};

export default function LabHistoryTable({ data }) {
  const modalRef = React.useRef(null);

  // Keep the id of the selected row plus a snapshot as a fallback.
  const [selectedId, setSelectedId] = React.useState(null);
  const [snapshot, setSnapshot] = React.useState({});

  // Always read the live row from `data` so the modal reflects refetched
  // values (e.g. after an edit). Fall back to the snapshot if the row is no
  // longer in the current list (e.g. after a search).
  const result = React.useMemo(
    () => data.find((r) => getRowId(r) === selectedId) || snapshot,
    [data, selectedId, snapshot]
  );

  const openResult = (row) => {
    setSelectedId(getRowId(row));
    setSnapshot(row);
    modalRef?.current?.handleToggle();
  };

  const closeModal = () => {
    modalRef?.current?.handleToggle();
  };

  return (
    <>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell align="left" sx={{ fontWeight: "bold" }}>
                S/N
              </TableCell>
              <TableCell align="left" sx={{ fontWeight: "bold" }}>
                Date
              </TableCell>

              <TableCell align="left" sx={{ fontWeight: "bold" }}>
                Unique ID
              </TableCell>
              <TableCell align="left" sx={{ fontWeight: "bold" }}>
                Patient Name
              </TableCell>
              <TableCell align="left" sx={{ fontWeight: "bold" }}>
                Age/Gender
              </TableCell>
              <TableCell align="left" sx={{ fontWeight: "bold" }}>
                Test By
              </TableCell>
              <TableCell align="left" sx={{ fontWeight: "bold" }}>
                Result
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((row, i) => (
              <Row key={getRowId(row) || i} row={row} i={i} openModal={openResult} />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <CustomModal
        ref={modalRef}
        backdropSx={{
          marginTop: "0px !important",
        }}
        childrenContSx={{
          p: 2,
          width: {
            xs: "90%",
            sm: "65vw",
          },
        }}
      >
        <TestResultModal data={result} handleClose={closeModal} />
      </CustomModal>
    </>
  );
}